export const countriesOptions = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
];
